'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateExtraCosts = undefined;

var _cart = require('@arreeba/ristoranti-lib/lib/cart');

var _cart2 = _interopRequireDefault(_cart);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateExtraCosts = exports.updateExtraCosts = function updateExtraCosts(state, services, actions) {
  var resolvedActions = actions.order ? actions.order : actions.orderAction;
  if (state.order.orderType === _constants.ORDER_TYPE_DELIVERY) {
    var order = state.order;
    var total = _cart2.default.total(order.cart);
    services.order.orderFetchExtraCosts(state.app.id, {
      total: total,
      targetDeliveryArea: order.deliveryAreaId,
      targetRestaurant: order.targetRestaurant
    }, resolvedActions);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/middleware-helpers/order.js
// module id = 414
// module chunks = 0